import { createAsyncThunk } from "@reduxjs/toolkit";
// urls
import * as URLS from "../../urls";
//axios
import axios from "../../utilies/axios";
//_________________________________________________

// GET =>  All PERMISSION SERVICE
export const getPermissionsService = createAsyncThunk(
  "general/getPermissionsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.permissionsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET =>  All NOTIFICATIONS SERVICE
export const getNotificationsService = createAsyncThunk(
  "general/getNotificationsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.notificationsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
//
// GET =>  All STATISTICS SERVICE
export const getStatisticsService = createAsyncThunk(
  "general/getStatisticsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.statisticsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// POST =>  CREATE USER SERVICE
export const createContactUservice = createAsyncThunk(
  "general/createUserService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.contactUsURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET =>  GET ALL CONTACT USER SERVICE
export const getAllContactUSerService = createAsyncThunk(
  "general/getAllContactUSerService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.contactUsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET =>  GET PRIVACY POLICY SERVICE
export const getPrivacyPolicyService = createAsyncThunk(
  "general/getPrivacyPolicyService",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(URLS.privacyPolicyURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET =>  GET DISCOUNT CODE SERVICE
export const getDiscountCouponsService = createAsyncThunk(
  "general/getDiscountCouponsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.discountCouponsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// POST =>  CREATE DISCOUNT CODE SERVICE
export const createDiscountCodeService = createAsyncThunk(
  "general/createDiscountCodeService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.discountCouponsURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// UPDATE =>  UPDATE PRODUCT SERVICE
export const updateDiscountCodeModal = createAsyncThunk(
  "general/updateCouponModal",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.discountCouponsURL}/${params?.id}`,
        params.formData
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// DELETE =>  DELETE DISOUNT CODE SERVICE
export const deleteDiscountCodeService = createAsyncThunk(
  "general/deleteDiscountCodeService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.delete(
        `${URLS.discountCouponsURL}/${params?.id}`
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET =>  All ADVERTISMENT SERVICE
export const getAdvertisementsService = createAsyncThunk(
  "general/getAdvertisementsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.advertisementsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// POST =>  CREATE ADVERTISMENT SERVICE
export const createAdvertismentService = createAsyncThunk(
  "general/createAdvertismentService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.advertisementsURL, data?.data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);


// UPDATE =>  UPDATE ADVE SERVICE
export const updateAdvertisementService = createAsyncThunk(
  "general/updateAdvertisementService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.post(
        `${URLS.advertisementsURL}/${params?.id}`,
        params.formData
      , {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// DELETE =>  DELETE ADVERTISMENT SERVICE
export const deleteAdvertismentService = createAsyncThunk(
  "general/deleteAdvertismentService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.delete(
        `${URLS.advertisementsURL}/${params?.id}`
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET =>  All STORE INFO  SERVICE
export const getStoreInfoService = createAsyncThunk(
  "general/getStoreInfoService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.storeInfoURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);